import React, {useCallback, useState} from "react";
import styles from "../../../admin-modules/emergency/emergency.module.scss";
import {useAppDispatch} from "../../../core/hooks";
import {customerDownloadContract, customerUploadContract, resetContract} from "../../requests/er-thunk";
import OfferToEvent from "../OfferToEvent";
import {Modal, Spinner} from "../../../shared";
import ResetModal from "../Agreement/ResetModal";

const UploadPdf = ({setShowAgreementsModal, contract}) => {
  const [openResetModal, setOpenResetModal] = useState(false)

  const dispatch = useAppDispatch()

  // const handleUploadFiles = useCallback(
  //   (e) => {
  //     // eslint-disable-next-line no-restricted-globals
  //     e.preventDefault();
  //     // @ts-ignore
  //     // eslint-disable-next-line no-restricted-globals
  //     const formData = new FormData();
  //     for (const f of e.target.files) {
  //       formData.append("file", f);
  //     }
  //     dispatch(customerUploadContract(formData))
  //     e.target.value = ""
  //   },
  //
  //   [dispatch]
  // );

  // const handleDownloadFiles = useCallback(
  //   () => {
  //     dispatch(customerDownloadContract(contract?.customer_upload))
  //   }, [dispatch, contract]
  // );

  return <div style={{width: "97%", margin: 8, padding: 16, background: '#F1F6FF', borderRadius: 16, justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex'}}>
    <div style={{flex: '1 1 0', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',display: 'inline-flex'}}>
      {contract?.status === 2 && <div style={{alignSelf: 'stretch', color: '#192233', fontSize: 14, wordWrap: 'break-word', display: "flex", justifyContent: "space-between", alignItems: "center"}}>Ожидает подтверждения от Заказчика  <Spinner/></div>}
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex'}}>
        {/* eslint-disable-next-line no-mixed-operators */}
        {(contract?.status === 3|| contract?.status === 4 ||  contract?.status === 5) &&<div
          onClick={() => setShowAgreementsModal(true)}
          style={{
          cursor: "pointer",
          flex: '1 1 0',
          height: 40,
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 10,
          paddingBottom: 10,
          background: 'white',
          borderRadius: 8,
          border: '1px #BDC1CC solid',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: 4,
          display: 'flex'
        }}>
          <div style={{
            flex: '1 1 0',
            height: 20,
            paddingLeft: 4,
            paddingRight: 4,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
          }}>
            <div style={{
              flex: '1 1 0',
              textAlign: 'center',
              color: '#192233',
              fontSize: 14,
              wordWrap: 'break-word'
            }}>Просмотреть договор
            </div>
          </div>
        </div>}


        {contract?.status === 3 && <div
          onClick={() => setOpenResetModal(true)}
          style={{
            cursor: "pointer",
            flex: '1 1 0',
            height: 40,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 10,
            paddingBottom: 10,
            background: 'white',
            borderRadius: 8,
            border: '1px #BDC1CC solid',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 4,
            display: 'flex'
          }}>
          <div style={{
            flex: '1 1 0',
            height: 20,
            paddingLeft: 4,
            paddingRight: 4,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
          }}>
            <div style={{
              flex: '1 1 0',
              textAlign: 'center',
              color: '#192233',
              fontSize: 14,
              wordWrap: 'break-word'
            }}>Пересмотр договора
            </div>
          </div>
        </div>}

        {/*<label style={{flex: '1 1 0',cursor: "pointer", height: 40, paddingLeft: 12, paddingRight: 12, paddingTop: 10, paddingBottom: 10, background: 'white', borderRadius: 8, border: '1px #BDC1CC solid', justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}} htmlFor='img-upload' className={styles.imgUploadWrapper}>*/}
        {/*  <div style={{flex: '1 1 0', justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex'}}>*/}
        {/*    <div style={{flex: '1 1 0', height: 20, paddingLeft: 4, paddingRight: 4, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>*/}
        {/*      <div style={{flex: '1 1 0', textAlign: 'center', color: '#192233', fontSize: 14,   wordWrap: 'break-word'}}>Загрузить договор</div>*/}
        {/*      <input id='img-upload'*/}
        {/*             accept="application/pdf"*/}
        {/*        onChange={handleUploadFiles}*/}
        {/*             className='hidden' type='file'/>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</label>*/}


      </div>
    </div>
    <Modal open={openResetModal}
           closeIcon
           className={styles.modal}
           title={'Пересмотр договора'}
           handleClose={() => {
             setOpenResetModal(false)
           }}>
      <ResetModal contract={contract}/>
    </Modal>
  </div>
}

export default UploadPdf
